import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

const ONE_DAY = 24 * 60 * 60 * 1000;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // 🔹 1️⃣ Restore session on refresh
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const expiryTime = localStorage.getItem('expiry');

    if (storedUser && expiryTime) {
      if (Date.now() < Number(expiryTime)) {
        setUser(JSON.parse(storedUser));
      } else {
        logout();
      }
    }
  }, []);

  // 🔥 2️⃣ ADD THIS RIGHT HERE (Auto Logout Checker)
  useEffect(() => {
    const interval = setInterval(() => {
      const expiryTime = localStorage.getItem('expiry');

      if (expiryTime && Date.now() > Number(expiryTime)) {
        logout();
      }
    }, 60000); // check every 1 minute

    return () => clearInterval(interval);
  }, []);

  const login = (userData) => {
    const expiry = Date.now() + ONE_DAY;

    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', userData.token);
    localStorage.setItem('expiry', expiry);

    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('expiry');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
